import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Api } from './api.service';
import { Claims } from '../../shared/models/claims.model';
import { Observable } from 'rxjs';
import { DataTableRequest, DataTableResponse, UpdateServicesAndConditionCommand } from '../services/service-proxies';

@Injectable()
export class ShipperApi extends Api {
  private controllerName = 'api/shipper';

  public create(user: Claims): Observable<any> {
    return this.post('api/shipper', { ObjectId: user.oid, Email: user.email, DisplayName: user.displayName, Type: user.type });
  }

  public update(data: any) {
    return this.put(this.controllerName, data);
  }

  public getRemainderCredit(shipperId) {
    const params = new HttpParams({

    });
    return this.get(`shipper/detail/${shipperId}/RemainderCredit`, params);
  }

  cancelRequest(id) {
    return this.get(`${this.controllerName}/cancel-request/${id}`);
  }

  getShipperProfile(modelId: string) {
    return modelId ? this.get(`${this.controllerName}/${modelId}`) : this.get(`${this.controllerName}`);
  }

  exitRequestBeforePayment(id) {
    return this.get(`${this.controllerName}/exit-request-before-payment/${id}`);
  }

  exitRequestAfterPayment(id) {
    return this.get(`${this.controllerName}/exit-request-after-payment/${id}`);
  }

  requestBookingRevision(id) {
    return this.get(`${this.controllerName}/request-booking-revision/${id}`);
  }

  getShipperDatatable(request: DataTableRequest): Observable<DataTableResponse> {
    return this.datatable(`api/shipper/get-datatable-shipper`, request);
  }

  getShipperStatistic() {
    return this.get(`${this.controllerName}/get-statistic-shipper`);
  }

  isShowList() {
    return this.get<any>(`${this.controllerName}/show-shipper-list`);
  }

  isShowFreightPostRequestList() {
    return this.get<any>(`${this.controllerName}/show-shipper-freight-post-request-list`);
  }

  isShowDeal() {
    return this.get<any>(`${this.controllerName}/show-shipper-deal`);
  }

  isShowRefund() {
    return this.get<any>(`${this.controllerName}/show-shipper-refund`);
  }

  isShowPenalty() {
    return this.get<any>(`${this.controllerName}/show-shipper-penalty`);
  }

  getShipperReward() {
    return this.get<any>(`${this.controllerName}/get-shipper-reward`);
  }

  public isExist(id: any): Observable<any> {
    return this.get(`${this.controllerName}/check-exist/${id}`);
  }

  updateServicesAndCondition(command: UpdateServicesAndConditionCommand) {
    return this.post(`${this.controllerName}/update-services-and-condition`, command);
  }

  downloadBusinessRegistrationsFile(id, fileName) {
    return this.download(fileName, `${this.controllerName}/download-business-registrations-file/${id}`);
  }
}
